import React from 'react';
import './prizes.css';
import Card from "../../components/Card/Card";
import CardHeader from "../../components/Card/CardHeader";
import CardBody from "../../components/Card/CardBody";
import SearchResultsHeader from '../../components/search-results-header/search-results-header';
import { Link, withRouter } from 'react-router-dom';
import Backdrop from '@material-ui/core/Backdrop';
import CircularProgress from '@material-ui/core/CircularProgress';
import Divider from '@material-ui/core/Divider';

class Prizes extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: true,
      prizes: null
    };
  }

  componentDidMount() {
    fetch("/api/get-prizes")
    .then(response => response.json())
    .then(result => {
      if (result.success) {
        this.setState({ prizes: result.data, isLoading: false });
      }
    })
    .catch(result => {
      this.props.history.push(`/error?message=${result.error ? result.error : "An unknown error has occured. Please try again later."}`);
    });
  }

  render() {
    return (
      <div className="prizes-wrap">
        <SearchResultsHeader
          handleSearch={ data => this.props.history.push(`/search?q=${data.q}&page=1`) }
          mainSearchStyle={{ transform: "translateX(-50%)",  left: "50%", maxWidth: "600px" }}
          user={ this.props.user }
          hideTabs={ false }
        />

        {
          this.state.isLoading ? 
            <Backdrop className="on-registration-back-drop" open={this.state.isLoading}>
              <CircularProgress color="inherit" />
            </Backdrop>
          :<>  
            <div className="prizes-element">
              <Card>
                <CardHeader color="primary">
                  <h2>Uzvy Daily Prizes</h2>
                  <h3><Link to="/registration">Join Uzvy today</Link> - as more people use Uzvy, we're able to offer bigger prizes.</h3>
                </CardHeader>
                <CardBody>
                  {
                    this.state.prizes.map((item, index) => {
                      return (
                        <>
                          { index === 0 ? <h2 className="cause-title">Current Prize</h2> : <h2 className="cause-title">Past Prize</h2> }
                          <div className="cause-container">
                            <img src={ item.IconUrl } alt={ item.Name } />
                            <div className="cause-details">
                              <h2>{ item.Name }</h2>
                              <p>{ item.Description }</p>
                            </div>
                          </div>
                          { index < this.state.prizes.length - 1 ? <Divider /> : null }
                        </>
                      )
                    })
                  }
                </CardBody>
              </Card>
            </div>
          </>
        }
        
      </div>
    );
  }
}

export default withRouter(Prizes);
